/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanBarcodeClassicIcon20Light = forwardRef('ScanBarcodeClassicIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3 3.5a.5.5 0 0 0-1 0v12a.5.5 0 0 0 1 0v-12Z" }),
        React.createElement("path", { d: "M5.5 3a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-1 0v-10a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M9 3.5a.5.5 0 0 0-1 0v10a.5.5 0 0 0 1 0v-10Z" }),
        React.createElement("path", { d: "M11.5 3a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-1 0v-12a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M15 3.5a.5.5 0 0 0-1 0v10a.5.5 0 0 0 1 0v-10Z" }),
        React.createElement("path", { d: "M18 3.5a.5.5 0 0 0-1 0v12a.5.5 0 0 0 1 0v-12Z" })));
});
